import Vue from 'vue'
import Router from 'vue-router'
import store from './../store'
import system from './modules/system'
import frontend from './modules/frontend'
import frontendRepo from '../api/repos/frontendRepo'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {    
      return {
        selector: to.hash
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    ...system,
    ...frontend
  ]
})

/// ////////////////////
// Before Each Route //
/// ////////////////////
router.beforeEach(async (to, from, next) => {

  const v = async () => {
    await frontendRepo.version();
  }

  v();
 
  // load view layout
  store.commit('app/setLayout', to.meta.layout + '-layout')
  next()

})

export default router
